import { render, staticRenderFns } from "./CampaignTransactions.vue?vue&type=template&id=2924f5f8&"
import script from "./CampaignTransactions.vue?vue&type=script&lang=js&"
export * from "./CampaignTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports